import React from 'react'
import {FlagENSquareSvg, FlagENSvg} from '../Svgs/FlagENSvg'
import {FlagVISquareSvg, FlagVISvg} from '../Svgs/FlagVISvg'
import {FlagFRSquareSvg, FlagFRSvg} from "../Svgs/FlagFRSvg";
import {FlagKOSquareSvg, FlagKOSvg} from "../Svgs/FlagKOSvg";

export const FlagIcon = ({
                           type,
                           ...props
                         }) => {
  switch (type) {
    case 'vi':
      return <FlagVISvg {...props} />
    case 'en':
      return <FlagENSvg {...props} />
    case 'fr':
      return <FlagFRSvg {...props} />
    case 'ko':
      return <FlagKOSvg {...props} />
    default:
      return <FlagVISvg {...props} />
  }
}
export const FlagIconSquare = ({
                           type,
                           ...props
                         }) => {
  switch (type) {
    case 'vi':
      return <FlagVISquareSvg {...props} />
    case 'en':
      return <FlagENSquareSvg {...props} />
    case 'fr':
      return <FlagFRSquareSvg {...props} />
    case 'ko':
      return <FlagKOSquareSvg {...props} />
    default:
      return <FlagVISquareSvg {...props} />
  }
}
